import React from "react";
import "./index.css";
import { createRoot } from 'react-dom/client';
import App from "./App";
import Modal from "react-modal";
import { GoogleOAuthProvider } from '@react-oauth/google';

Modal.setAppElement("#root");

const container = document.getElementById('root');
const root = createRoot(container);
root.render(   
    <GoogleOAuthProvider clientId="345458734649-8rqesv2a1vralmp8g2kis6hg636g4lot.apps.googleusercontent.com">
        <App />
    </GoogleOAuthProvider>
    );